/** 简易 unified diff（行级），供技能包编辑器展示变更。 */
export function unifiedLineDiff(path: string, before: string, after: string): string {
  if (before === after) return "";

  const beforeLines = before.split("\n");
  const afterLines = after.split("\n");
  const header = [`--- a/${path}`, `+++ b/${path}`, "@@"];
  const body: string[] = [];

  const maxLen = Math.max(beforeLines.length, afterLines.length);
  for (let index = 0; index < maxLen; index += 1) {
    const left = beforeLines[index];
    const right = afterLines[index];
    if (left === right) {
      if (left !== undefined) body.push(` ${left}`);
    } else {
      if (left !== undefined) body.push(`-${left}`);
      if (right !== undefined) body.push(`+${right}`);
    }
  }

  return [...header, ...body].join("\n");
}

/** 合并多文件相对 lastSaved 的 diff 文本。 */
export function packageDiffFromBaseline(
  current: Record<string, string>,
  baseline: Record<string, string>,
): string {
  const paths = new Set([...Object.keys(current), ...Object.keys(baseline)]);
  const chunks: string[] = [];

  for (const path of Array.from(paths).sort()) {
    const chunk = unifiedLineDiff(path, baseline[path] ?? "", current[path] ?? "");
    if (chunk) chunks.push(chunk);
  }

  return chunks.join("\n\n");
}
